import { jsx as _jsx } from "react/jsx-runtime";
import { useCurrentClientConfig } from '@src/hooks/useCurrentClientConfig';
import { SegmentWrapper as SegmentWrapperBase } from 'pe-core-frontend';
/**
 * A wrapper component that enables Segment tracking based on the current client configuration.
 *
 * @param {PropsWithChildren} props - The properties passed to the component.
 * @param {React.ReactNode} props.children - The child components to be wrapped.
 *
 * @returns {JSX.Element} The wrapped children components
 */
export const SegmentWrapper = ({ children }) => {
    const { clientConfig, loading } = useCurrentClientConfig();
    return (_jsx(SegmentWrapperBase, { enabled: !loading && !clientConfig?.extraData?.disableSegment, children: children }));
};
